import _ from 'lodash';

// import { cjsStage } from './cjsStage';

export default {
  methods: {
    setDataGame(id) {
      try {
        switch (id) {
          case 'gallery':
            this.svgStage = new svgGallery(this.startGameConfig);
            break;
            deafult: this.svgStage = null;
            break;
        }
      } catch (e) {
        console.log(e);
      }
    },

    /**
     * Funkcja inicjująca grę
     *
     * @returns {undefined}
     */
    initGame() {
      this.resetCheckStatus();
      //     this.cjsStage.setStage();
      //    this.cjsStage.loadSamples();
    },
    newGame() {
      // ...
      this.initGame();
    },
  },
  computed: {},
  watch: {},
};

class svgGallery {
  constructor(obj) {}
}
